import { Switch, Text } from '@fluentui/react-components';
import { format } from 'date-fns';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { DateTimePicker } from '../../shared-components/date-time-picker';
import './SendOnSection.scss';

const SendOnSectionImpl: React.FC = () => {
  const {
    createOrEditEmailTemplatePageUiStore,
    timeZoneStore,
  } = useStores();

  const handleSendNowChecked = (checked: boolean): void => {
    if (checked) {
      createOrEditEmailTemplatePageUiStore.setSendNow();
    } else {
      createOrEditEmailTemplatePageUiStore.setScheduledSend();
    }
  };

  const handleDateTimeChange = (date?: Date): void => {
    createOrEditEmailTemplatePageUiStore.setEmailTemplateRequestBody<string | undefined>({
      key: 'sendOnDateTime',
      value: date ? format(date, "yyyy-MM-dd'T'HH:mm:ss") : undefined,
    });
  };

  const handleTimeZoneChange = (timeZone: string): void => {
    createOrEditEmailTemplatePageUiStore.setEmailTemplateRequestBody<string>({
      key: 'sendOnTimeZone',
      value: timeZone,
    });
  };

  return (
    <div className='send-on-section'>
      <div>
        <Text
          block
          weight='semibold'
        >
          Send now?
        </Text>
        <Switch
          label={createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.isSendNow ? 'Yes' : 'No'}
          value={createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.isSendNow ? 'yes' : 'no'}
          onChange={(_, data) => handleSendNowChecked(data.checked)}
          checked={!!createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.isSendNow}
        />
      </div>
      {!createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.isSendNow && (
        <div>
          <Text weight='semibold'>Send on</Text>
          <DateTimePicker
            dateLabel='Send on date'
            timeLabel='Send on time'
            datePlaceholder='Select a date'
            dateTime={createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.sendOnDateTime ?? undefined}
            timeZones={timeZoneStore.timeZones}
            timeZone={createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.sendOnTimeZone ?? undefined}
            onDateTimeChange={handleDateTimeChange}
            onTimeZoneChange={handleTimeZoneChange}
          />
          {createOrEditEmailTemplatePageUiStore.isBeingValidated && !createOrEditEmailTemplatePageUiStore.isDateTimeToSendValid && (
            <Text
              size={200}
              className='text--red'
              block
            >
              {createOrEditEmailTemplatePageUiStore.dateTimeValidationMessage}
            </Text>
          )}
        </div>
      )}
    </div>
  );
};

export const SendOnSection = observer(SendOnSectionImpl);
